import { createSelector } from '@ngrx/store';
import { MarketState } from '../state/market.state';
import { AppState } from '@store/state/app.state';

const selectMarkets = (state: AppState): MarketState => state.markets;

export const getMarkets = createSelector(
    selectMarkets,
    (state: MarketState) => state.list
);

export const getFavoriteMarkets = createSelector(
    selectMarkets,
    (state: MarketState) => state.list.filter(market => market.favoriteId)
);

export const getAlertMarkets = createSelector(
    selectMarkets,
    (state: MarketState) => state.list.filter(market => market.hasAlert)
);

export const getHomeMarkets = createSelector(
    selectMarkets,
    (state: MarketState) => state.home
);

// Loading only while there is nothing to show yet (e.g. first visit)
export const isMarketsLoading = createSelector(
    selectMarkets,
    (state: MarketState) => state.loading?.list && !state.list.length
);

export const isHomeMarketsLoading = createSelector(
    selectMarkets,
    (state: MarketState) => state.loading?.home && !state.home.length
);

export const getMarketDetails = createSelector(
    selectMarkets,
    (state: MarketState) => state.details
);

export const getMarketFilters = createSelector(
    selectMarkets,
    (state: MarketState) => state.filter
);
